// extracted by mini-css-extract-plugin
export var graphic = "HowWeGiveBack-module--graphic--1u5Qb";
export var svg = "HowWeGiveBack-module--svg--2lmqI";